module.exports = __webpack_public_path__ + "static/app-icon-1a6a6e75237c0448942c0fb4ef9abfc8.svg";